export default "__VITE_ASSET__DNt_u5VO__"